module.exports = __webpack_public_path__ + "static/media/star.303e355f.svg";